<template>
  <div>
    <!--考生信息-->
    <div class="bold fs22 pdBtm20 mrBtm20 borBtmdd">个人信息</div>
    <!--填写基本信息-->
    <div class="warp">
      <el-row>
        <!--姓名-->
        <el-col :span="12" :xs="24" class="dif alc item">
          <div class="fs16 dif alc ">
            <span style="color: #EE2352">*</span>
            <div class="col101010" style="font-size: 14px;">姓名</div>
          </div>
          <div class="mrLft20 w70">
            <el-input placeholder="请输入姓名" :disabled="is_disabled" v-model="name"></el-input>
          </div>
        </el-col>
        <!--民族-->
        <el-col :span="12" :xs="24" class="dif alc item">
          <div class="fs16 dif alc ">
            <span style="color: #EE2352">*</span>
            <div class="col101010" style="font-size: 14px;">民族</div>
          </div>
          <div class="mrLft20 w70">
            <el-select v-model="nation">
              <el-option
                v-for="(item,index) in nations" :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <!--性别-->
        <el-col :span="12" :xs="24" class="dif alc item">
          <div class="fs16 dif alc ">
            <span style="color: #EE2352">*</span>
            <div class="col101010" style="font-size: 14px;">性别</div>
          </div>
          <div class="mrLft20 w70">
            <el-radio v-model="gender" label="1" :disabled="is_disabled">男</el-radio>
            <el-radio v-model="gender" label="2" :disabled="is_disabled">女</el-radio>
          </div>
        </el-col>
        <!--出生日期-->
        <el-col :span="12" :xs="24" class="dif alc item">
          <div class="fs16 dif alc ">
            <span style="color: #EE2352">*</span>
            <div class="col101010" style="font-size: 14px;">出生日期</div>
          </div>
          <div class="mrLft20 w70">
            <el-date-picker
                v-model="birth"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-col>
        <!--是否工作-->
        <el-col :span="12" :xs="24" class="dif alc item">
          <div class="fs16 dif alc ">
            <span style="color: #EE2352">*</span>
            <div class="col101010" style="font-size: 14px;">是否工作</div>
          </div>
          <div class="mrLft20 w70">
            <el-radio v-model="is_work" label="1" :disabled="is_disabled">是</el-radio>
            <el-radio v-model="is_work" label="0" :disabled="is_disabled">否</el-radio>
          </div>
        </el-col>
        <!--身份证号-->
        <el-col :span="12" :xs="24" class="dif alc item">
          <div class="fs16 dif alc ">
            <span style="color: #EE2352">*</span>
            <div class="col101010" style="font-size: 14px;">身份证号</div>
          </div>
          <div class="mrLft20 w70">
            <el-input placeholder="请输入身份证号" maxlength="18" v-model="number" :disabled="is_disabled"></el-input>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="button difcac colfff pointer" @click="upDateInfo()">保存设置</div>
  </div>
</template>

<script>
export default {
  name: "userInfo",
  data() {
    return {
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      nations: ["汉族","蒙古族","回族","藏族","维吾尔族","苗族","彝族","壮族","布依族","朝鲜族","满族","侗族","瑶族","白族","土家族",
        "哈尼族","哈萨克族","傣族","黎族","傈僳族","佤族","畲族","高山族","拉祜族","水族","东乡族","纳西族","景颇族","柯尔克孜族",
        "土族","达斡尔族","仫佬族","羌族","布朗族","撒拉族","毛南族","仡佬族","锡伯族","阿昌族","普米族","塔吉克族","怒族", "乌孜别克族",
        "俄罗斯族","鄂温克族","德昂族","保安族","裕固族","京族","塔塔尔族","独龙族","鄂伦春族","赫哲族","门巴族","珞巴族","基诺族"],
      is_disabled: false,
      name: '',//姓名
      nation: '汉族',//民族
      gender: '1',//性别
      birth: '',//出生日期
      is_work: '1',//是否工作
      number: '',//身份证
    }
  },
  methods: {
    //获取用户信息
    getUserInfo() {
      this.$axios("POST","/user/info",{},'加载中')
      .then(res => {
        if(res.code===1) {
          //存入信息
          this.name = res.data.name
          this.nation = res.data.mz || ''
          this.gender = res.data.sex
          if(res.data.date_time!=='0000-00-00') {
            this.birth = res.data.date_time
          }
          this.is_work = res.data.is_gz
          this.number = res.data.id_card || ''

          //将信息存入缓存中
          let info = {
            id: res.data.id,
            phone: res.data.phone,
            sex: res.data.sex,
            name: res.data.name,
            image: res.data.image
          }
          this.$store.commit('login',info)
        }else {
          this.$alert(res.msg)
        }
      })
    },
    //修改用户信息
    upDateInfo() { //修改用户信息
      if(this.name==='') {
        this.$alert('请输入姓名')
        return
      }else if(this.nation==='') {
        this.$alert('请选择民族')
        return
      }else if(this.birth==='') {
        this.$alert('请选择出生日期')
        return
      }else if(this.number==='') {
        this.$alert('请输入身份证号')
        return
      }

      let data = {
        name: this.name,
        mz: this.nation,
        date_time: this.birth,
        id_card: this.number,
        is_gz: this.is_work,
        sex: this.gender
      }
      this.$axios("POST","/user/up_info",data,"加载中")
      .then(res => {
        if(res.code===1) {
          this.$alert('保存成功')
          .then(six => {
            this.getUserInfo()
          })
        }else {
          this.$alert(res.msg)
        }
      })
    },
  },
  created() {
    this.getUserInfo()
  }
}
</script>

<style scoped>
  .warp{
    width: 100%;
    background: #E5FFFA;
    box-sizing: border-box;
    padding: 2rem;
  }
  .item{
    height: 60px;
    box-sizing: border-box;
  }
  .button{
    margin: 10rem auto;
    height: 4.5rem;
    width: 13.4rem;
    background: #e17835;
    font-size: 1.6rem;
  }
</style>